import { useCallback, useContext } from 'react';
import GeneralContext from '@/context/GeneralContext';

const useModalDefinition = () => {
  const { modalDefinitions } = useContext(GeneralContext);
  return useCallback(
    (id: string, language: string) => {
      const modalDefinition = modalDefinitions[language][id];
      if (!modalDefinition) {
        throw new Error(`Modal with id "${id}" not found`);
      }

      return modalDefinition;
    },
    [modalDefinitions]
  );
};

export default useModalDefinition;
